'use strict';

import Media from '../../../js/imports/media.js';
import debounce from 'lodash.debounce';

class HpHero {
    internal;
    ui;
    wrap;

    constructor(options) {
        if (options.wrap) {
            this.wrap = options.wrap;
        }

        if (this.wrap) {
            this.ui = {
                imgLgEl: document.querySelector('.js-hero-image-lg'),
                imgMdEl: document.querySelector('.js-hero-image-md'),
                imgSmEl: document.querySelector('.js-hero-image-sm'),
                heroLinkEl: document.querySelector('.js-hero-link'),
                headingEl: this.wrap.querySelector('.js-hero-heading-wrap'),
                h1El: document.querySelector('.js-hero-h1'),
                h2El: document.querySelector('.js-hero-h2'),
                imageContainerEl: document.querySelector('.js-hero-image-container')
            };

            this.internal = {
                data: this.wrap.querySelector('.js-hero-data'),
                imgLg: false,
                imgMd: false,
                imgSm: false,
                heroLink: false,
                heroTarget: false,
                h1: false,
                h2: false,
                imgSmLoaded: false,
                imgMdLoaded: false,
                imgLgLoaded: false,
                resizeTimeout: 0
            };

            if (this.internal.data) {
                this.setHeroData();
            }

            this.onLoad();
        }
    }

    onLoad() {
        window.addEventListener('load', () => this.windowLoad());
    }

    onResize() {
        window.addEventListener('resize', () => this.windowResize());
    }

    windowLoad() {
        this.showHeading();
    }

    windowResize() {
        this.loadImages();
    }

    showHeading() {
        // console.log('inside show heading');
        if (this.ui.headingEl) {
            this.ui.headingEl.classList.add('is-visible');
        }
    }

    setHeroData() {
        const rnd = Math.floor(Math.random() * this.internal.data.childElementCount),
            selectedHero = this.internal.data.children[rnd],
            replaceParens = function (uri) {
                return uri.replace(/\(/g, '%28').replace(/\)/g, '%29');
            };

        this.internal.imgLg = encodeURI(selectedHero.getAttribute('data-hero-image-lg'));
        this.internal.imgLg = replaceParens(this.internal.imgLg);
        this.internal.imgMd = encodeURI(selectedHero.getAttribute('data-hero-image-md'));
        this.internal.imgMd = replaceParens(this.internal.imgMd);
        this.internal.imgSm = encodeURI(selectedHero.getAttribute('data-hero-image-sm'));
        this.internal.imgSm = replaceParens(this.internal.imgSm);

        this.internal.h1 = selectedHero.getAttribute('data-hero-h1');
        this.internal.h2 = selectedHero.getAttribute('data-hero-h2');
        this.internal.heroLink = encodeURI(selectedHero.getAttribute('data-hero-link'));
        this.internal.heroTarget = selectedHero.getAttribute('data-hero-target');

        this.setHeroEl();
    }

    setHeroEl() {
        if (this.ui.h1El) {
            this.ui.h1El.innerHTML = this.internal.h1;
        }

        if (this.ui.h2El) {
            this.ui.h2El.innerHTML = this.internal.h2;
        }

        if (this.ui.heroLinkEl) {
            this.ui.heroLinkEl.href = this.internal.heroLink;

            if (this.internal.heroTarget) {
                this.ui.heroLinkEl.setAttribute('target', this.internal.heroTarget);
            }
        }

        if (this.internal.imgMd && this.internal.imgLg) {
            if (this.ui.imgMdEl && this.ui.imgLgEl) {
                this.loadImages();
                this.onResize();
            }
        }

        // Show link icon on correct heading
        if (this.internal.heroLink) {
            if (this.internal.h1 && this.internal.h2) {
                this.ui.h2El.classList.add('show-link-icon');
            } else if (this.internal.h1 && !this.internal.h2) {
                this.ui.h1El.classList.add('show-link-icon');
            } else if (!this.internal.h1 && this.internal.h2) {
                this.ui.h2El.classList.add('show-link-icon');
            }
        }
    }

    createImageLink(imagePath) {
        const link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'preload';
        link.fetchPriority = 'high';
        document.head.appendChild(link);
        link.href = imagePath;
    }

    loadImages() {
        if (!this.internal.imgSmLoaded || !this.internal.imgMedLoaded || !this.internal.imgLgLoaded) {
            var img = new Image();

            if (!this.internal.imgSm && !this.internal.imgSmLoaded && Media().init('mq-small')) {
                this.internal.imgSmLoaded = true;
                this.createImageLink(img.src);
            } else if (this.internal.imgSm && !this.internal.imgSmLoaded && Media().init('mq-small')) {
                // Load small image
                img.src = this.internal.imgSm;
                this.internal.imgSmLoaded = true;
                this.createImageLink(img.src);

            } else if (!this.internal.imgMdLoaded && Media().init('mq-medium')) {
                // Load medium image
                img.src = this.internal.imgMd;
                this.internal.imgMdLoaded = true;
                this.createImageLink(img.src);
            } else if (!this.internal.imgLgLoaded && Media().init('mq-large')) {
                // Load large image
                img.src = this.internal.imgLg;
                this.internal.imgLgLoaded = true;
                this.createImageLink(img.src);
            }

            img.onload = () => {
                this.ui.imageContainerEl.classList.add('is-loaded');
            };
        }
    }
}

export default HpHero;
